import { Delete, Edit, OpenInNew } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import local from "dayjs/plugin/localizedFormat";

dayjs.extend(utc);
dayjs.extend(local);
const columns = (deleteClick, openSimulation) => [
  { field: "creator_email", headerName: "Creator", flex: 1 },
  {
    field: "description",
    headerName: "Description",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) =>
      (params.value === null) |
      (params.value === "") |
      (params.value === undefined)
        ? "-"
        : params.value,
  },
  {
    field: "owner1",
    headerName: "Owner 1",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) =>
      (params.value === null) |
      (params.value === "") |
      (params.value === undefined)
        ? "-"
        : params.value,
  },
  {
    field: "owner2",
    headerName: "Owner 2",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) =>
      (params.value === null) |
      (params.value === "") |
      (params.value === undefined)
        ? "-"
        : params.value,
  },
  {
    field: "owner3",
    headerName: "Owner 3",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) =>
      (params.value === null) |
      (params.value === "") |
      (params.value === undefined)
        ? "-"
        : params.value,
  },
  {
    field: "last_update",
    headerName: "Last update",
    flex: 1,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => {
      if (typeof params.value === "string") {
        // return params.value.split(".")[0]; 
        return dayjs.utc(params.value).local().format("YYYY-MM-DD HH:mm:ss") // UTC -> Locale
      }
    },
  },
  {
    field: "action",
    headerName: "Action",
    sortable: false, //no ordinamento
    filterable: false, //no filtri
    disableColumnMenu: true, //disabilita menu
    align: "center",
    headerAlign: "center",
    width:150,
    renderCell: (params) => (
      <Box>
        <IconButton onClick={() => deleteClick(String(params.row.id))}>
          <Delete />
        </IconButton>
        <IconButton onClick={() => openSimulation(params.row)}>
          <OpenInNew />
        </IconButton>
      </Box>
    ),
  },
];
export default columns;
